import { Box, Typography } from '@mui/material';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: 'inherit',
};
const messageStyle = { textAlign: 'center' };

const Message = ({ message }) => {
  return (
    <Box sx={containerStyle}>
      <Typography variant="h4" gutterBottom component="div" sx={messageStyle}>
        {message}
      </Typography>
    </Box>
  );
};

export default Message;
